import axios from 'axios';
import axiosAbc from '../../axios-orders';

import * as actionTypes from './actionTypes';

export const authStart = () => {
    return {
        type: actionTypes.AUTH_START
    };
};

export const authSuccess = (token, userId, userEmail, org, admin,userName) => {
    return {
        type: actionTypes.AUTH_SUCCESS,
        idToken: token,
        userId: userId,
        userEmail: userEmail,
        userName: userName,
        org: org,
        admin: admin,
    };
};

export const authFail = (error) => {
    return {
        type: actionTypes.AUTH_FAIL,
        error: error
    };
};

export const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('expirationDate');
    localStorage.removeItem('userId');
    localStorage.removeItem('useremail');
    localStorage.removeItem('username');
    localStorage.removeItem('admin');
    return {
        type: actionTypes.AUTH_LOGOUT
    };
};

export const checkAuthTimeout = (expirationTime) => {
    return dispatch => {
        setTimeout(() => {
            dispatch(logout());
        }, expirationTime * 1000);
    };
};

export const auth = (email, password, name, isSignup) => {
    //alert("name:"+name);
    return dispatch => {
        dispatch(authStart());
        const authData = {
            email: email,
            password: password,
            returnSecureToken: true
        };
        let url = 'https://identitytoolkit.googleapis.com/v1/accounts:signUp?key=AIzaSyB_ajpYghy8SO4sEELKCf_kiCTvu0-ftmA';
        if (!isSignup) {
            url = 'https://identitytoolkit.googleapis.com/v1/accounts:signInWithPassword?key=AIzaSyB_ajpYghy8SO4sEELKCf_kiCTvu0-ftmA';
        }
        axios.post(url, authData)
            .then(response => {

                //alert("idSignup:"+isSignup);
                if (isSignup) {
                    const userName = {
                        name: name,
                        id: email
                      };
            
                      axiosAbc.post( '/userName.json?', userName )
                      .then( response => {
                           //alert("saved name and id")
                      } )
                      .catch( error => {
                          alert( "error:"+error ) ;
                    } );
            
                }        

                const queryParams1 = '?orderBy="id"&equalTo="' + email + '"';
                //alert("queryParams1:"+queryParams1);
                axiosAbc.get( '/userData.json'+queryParams1)
                .then(userData1 => {
                    //alert("org:"+JSON.stringify(userData1.data));
                    var userData=userData1.data;
                    var org = 'unknown';
                    var admin = false;
                    if (Object.keys(userData).length === 0){
                        alert("User account pending activation. Please contact app admin (alibookclub.org@gmail.com) to activate your account");
                        dispatch(authFail("user id not found"));                        
                        throw new Error('failed');

                    }         
                    
                    let userName = '';
                    axiosAbc.get( '/userName.json'+queryParams1)
                    .then(userNameObj => {
                        var userNameObj1 = userNameObj.data;
                        for (var key in userNameObj1) {
                            if (userNameObj1.hasOwnProperty(key)) {  
                                //alert("key:"+key);
                                var obj = userNameObj1[key];
    
                                //alert("obj:"+JSON.stringify(obj));
                                userName = obj.name;
                                //alert("userName inside:"+userName);
                            }
                        }


                        for (var key in userData) {
                            if (userData.hasOwnProperty(key)) {  
                                //alert("key:"+key);
                                var obj = userData[key];
    
                                //alert("obj:"+JSON.stringify(obj));
                                org = obj.org;
                                var id1 = obj.id;
                                admin = obj.admin;
                                //alert("org inside:"+org);
                                if(id1 === email)
                                {
                                    //alert("user id match");
                                }
                                else
                                {
                                    //alert("user id does not match");
                                    dispatch(authFail("user not in the list"));        
                                }
                            }
        
                        }   
                        //alert("org:"+org);
                        //localStorage.setItem('org', org);
                        
    
                        //alert("username outside:"+userName);
    
                        const expirationDate = new Date(new Date().getTime() + response.data.expiresIn * 1000);
                        localStorage.setItem('token', response.data.idToken);
                        localStorage.setItem('expirationDate', expirationDate);
                        localStorage.setItem('userId', response.data.localId);
                        localStorage.setItem('userEmail', response.data.email);
                        localStorage.setItem('userName', userName);
                        //alert("auth data...:"+JSON.stringify(response));
                        dispatch(authSuccess(response.data.idToken, response.data.localId, response.data.email, org, admin,userName));
                        dispatch(checkAuthTimeout(response.data.expiresIn));
    



                        } )
                    .catch( error => {
                        alert( "error:"+error ) ;
                    } );
  

                })
                .catch(err => {
                        dispatch(authFail("user not found"));
                });
        
            })
            .catch(err => {
                dispatch(authFail(err.response.data.error));
            });
    };
};

export const setAuthRedirectPath = (path) => {
    return {
        type: actionTypes.SET_AUTH_REDIRECT_PATH,
        path: path
    };
};

export const authCheckState = () => {
    return dispatch => {
        const token = localStorage.getItem('token');
        var org = 'unknown';
        var admin = false;
        const userId = localStorage.getItem('userId');
        const userEmail = localStorage.getItem('userEmail');
        const userName = localStorage.getItem('userName');


        if (!token) {
            dispatch(logout());
        } else {
            const expirationDate = new Date(localStorage.getItem('expirationDate'));
            if (expirationDate <= new Date()) {
                dispatch(logout());
            } else {









                const queryParams1 = '?orderBy="id"&equalTo="' + userEmail + '"';
                //alert("queryParams1:"+queryParams1);
                axiosAbc.get( '/userData.json'+queryParams1)
                .then(userData1 => {
                    //alert("org:"+JSON.stringify(userData1.data));
                    var userData=userData1.data;
                    if (Object.keys(userData).length === 0){
                        alert("User account not found. Contact whatsapp group admin and check your account is enabled");
                        dispatch(authFail("user id not found"));                        
                        throw new Error('failed');

                    }
                    for (var key in userData) {
                        if (userData.hasOwnProperty(key)) {  
                            //alert("key:"+key);
                            var obj = userData[key];

                            //alert("obj:"+JSON.stringify(obj));
                            org = obj.org;
                            var id1 = obj.id;
                            admin = obj.admin;
                            //alert("org inside:"+org);
                            if(id1 === userEmail)
                            {
                                //alert("user id match");
                                dispatch(authSuccess(token, userId,userEmail,org,admin,userName));
                            }
                            else
                            {
                                //alert("user id does not match");
                                dispatch(authFail("user not in the list"));        
                            }
                        }
    
                    }   
                })

                //alert("org outside:"+org);










                dispatch(authSuccess(token, userId,userEmail,org,admin,userName));
                dispatch(checkAuthTimeout((expirationDate.getTime() - new Date().getTime()) / 1000 ));
            }   
        }
    };
};


// WEBPACK FOOTER //
// ./src/store/actions/auth.js